export const compareObject = (a = {}, b = {}) => {
  if (a === b) return true;
  if ((Array.isArray(a) && !Array.isArray(b)) || (!Array.isArray(a) && Array.isArray(b))) return false;
  const aggregate = { ...a, ...b };
  for (const key in aggregate) {
    if (typeof a[key] === "object" && typeof b[key] === "object") {
      return compareObject(a[key], b[key]);
    }
    if (a[key] !== b[key]) return false;
  }
  return true;
};

export function getBaseName() {
  const baseEl = document.querySelector('base[href]');
  if (baseEl) {
    return baseEl.getAttribute('href').replace(/\/$/, '');
  }
  return '';
}